import script from "./BookingMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingMenu.vue?vue&type=script&setup=true&lang=js"

import "./BookingMenu.vue?vue&type=style&index=0&id=2e62ffe6&lang=scss"

const __exports__ = script;

export default __exports__